<template>
  <div class="c-common-weak">
    <div class="s-container">
      <div class="f-label">选择班级:</div>
      <el-col :span="5">
        <el-select v-model="searchForm.class_id" placeholder="选择班级">
          <el-option
            v-for="(c, i) in this.classList"
            :value="c.code"
            :label="c.name"
            :key="i"
          ></el-option>
        </el-select>
      </el-col>
      <el-radio v-model="radio" label="1"> 选择产生时间: </el-radio>
      <el-select v-model="selectedYear" placeholder="选择产生时间">
        <el-option
          v-for="(year, i) in yearList"
          :key="i"
          :value="year.value"
          :label="year.label"
        ></el-option>
      </el-select>
      <el-radio v-model="radio" label="2" class="ml-10">
        选择自定义时间:
      </el-radio>
      <el-date-picker
        popper-class="picker-ppp"
        @change="pickChange"
        v-model="dateRange"
        type="daterange"
        unlink-panels
        range-separator="至"
        :default-value="Date.now() - 29 * 24 * 3600 * 1000"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </div>
    <div class="hr"></div>
    <div class="create-at-content">
      <div class="f-left" ref="container" v-if="this.exerciseType">
        <div class="selector-container">
          <div
            class="version-header"
            @click="showVersion = !showVersion"
            :class="showVersion ? 'is-blue' : ''"
          >
            <p
              v-if="
                category.subjectId !== '' &&
                category.gradeId !== '' &&
                category.textbookId !== '' &&
                notCnEn(category.subjectId)
              "
            >
              <span class="result-text">{{ category.subjectName }}</span> -
              <span class="result-text"
                >{{ category.gradeName }}{{ category.termName }}</span
              >
              -
              <span class="result-text">{{ category.textbookName }}</span>
            </p>
            <p v-else>请选择教材版本</p>
          </div>
          <!-- 练习选择教材版本 -->
          <choise-category
            v-if="showVersion"
            type="CommonWeak"
            :classId="searchForm.class_id"
            fromType="6"
            @hideSubjectGradeText="hideSubjectGradeText"
          ></choise-category>
        </div>
        <!-- 理科选择知识点 -->
        <choose-knowledgePoints
          :data="chapterList"
          @changeCourse="onChangeCourse"
          multi
          :showTag="false"
          type="CommonWeak"
          v-if="scienceArr.includes(Number(this.category.subjectId))"
        ></choose-knowledgePoints>
      </div>
      <!-- 测评中心过来的 -->
      <div class="f-left" ref="container" v-else>
        <div class="selector-container">
          <div
            class="version-header"
            @click="showVersion = !showVersion"
            :class="showVersion ? 'is-blue' : ''"
          >
            <p
              v-if="
                category.subjectName !== '' &&
                category.versionsName !== '' &&
                category.gradeName !== '' &&
                notCnEn(category.subjectId)
              "
            >
              <span class="result-text">{{ category.subjectName }}</span>
              -
              <span class="result-text">{{ category.gradeName }}</span>
              -
              <span class="result-text">{{ category.versionsName }}</span>
            </p>
            <p v-else>请选择教材版本</p>
          </div>
          <!-- 测评选择教材版本 -->
          <ChoiseEvaCategory
            ref="ChoiseEvaCategory"
            type="EvaCommonWeak"
            @change="onDataChange"
            :classId="searchForm.class_id"
            v-show="showVersion"
            @hideSubjectGradeText="hideSubjectGradeText"
            :exerciseType="exerciseType"
          ></ChoiseEvaCategory>
          <!-- 理科选择知识点 -->
          <choose-knowledgePoints
            :data="chapterList"
            @changeCourse="onChangeCourse"
            multi
            :showTag="false"
            v-if="scienceArr.includes(Number(this.category.subjectId))"
          ></choose-knowledgePoints>
        </div>
      </div>
      <div class="f-main">
        <div class="point-content">
          <div class="c-header" style="margin-bottom: 7px">
            <p class="c-title" v-show="currentCourseName">
              {{ currentCourseName }}
            </p>
            <div class="f-s-b">
              <span class="c-subtitle">薄弱知识点数：{{ total || 0 }}个</span>
              <div v-if="this.exerciseType">
                <span class="c-text" v-if="checkedWeakPointList.length > 0"
                  >已选择<i>{{ checkedWeakPointList.length }}</i
                  >个</span
                >
                <button
                  class="c-cancel"
                  v-if="checkedWeakPointList.length > 0"
                  @click="onCancelClick"
                >
                  取 消
                </button>
                <button
                  :class="
                    checkedWeakPointList.length > 0
                      ? 'c-confirm'
                      : 'c-no-confirm'
                  "
                  @click="onConfirmPublish"
                  :disabled="checkedWeakPointList.length === 0"
                >
                  <i class="el-icon-plus"></i> 布置薄弱知识点巩固练习
                </button>
              </div>
            </div>
          </div>
          <el-table
            :data="packInfoList"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            @sort-change="onSortChange"
          >
            <div slot="empty" class="no-data">
              <img src="../images/data_empty.png" alt="" />
              <p>暂无薄弱知识点～</p>
            </div>
            <el-table-column
              label="全选"
              type="selection"
              width="50"
              v-if="exerciseType"
            >
            </el-table-column>
            <el-table-column
              label="知识点名称"
              prop="tag_name"
            ></el-table-column>
            <el-table-column
              label="班级平均掌握程度"
              prop="avg_ability"
              sortable
            >
              <template slot-scope="scope">
                <span class="c-progress">
                  <i :style="{ width: scope.row.avg_ability * 100 + '%' }"></i>
                </span>
                <span :class="getRateClass(scope.row.avg_ability * 100)">
                  {{ parseInt(scope.row.avg_ability * 100) }}%</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="掌握薄弱人数/学习人数"
              prop="rate"
              sortable
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <span
                  class="c-view"
                  @click="handleEdit(scope.$index, scope.row)"
                  >查看详情</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="cancel-mask" v-show="visibleCancel">
      <div class="cancel-dialog">
        <div class="dialog-content">
          <p>是否确认取消布置？</p>
          <p>取消后，将不会保留之前所选的内容</p>
        </div>
        <footer class="btns">
          <button class="btn-cancel" @click="onCancelPublish">不再布置</button>
          <button class="btn-confirm" @click="visibleCancel = false">
            继续布置
          </button>
        </footer>
      </div>
    </div>
    <LoDialog
      :visible.sync="visibleLo"
      :code="currentTagCode"
      :data="packInfoList"
      :searchForm="searchForm"
      :time="time"
      :courseId="this.currentCourseId"
      :classList="classList"
      :classId="searchForm.class_id"
      :category="this.category"
      :testId="testId"
      :radio="radio"
      :subjectId="subjectId"
      v-if="visibleLo"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CACHED_CLASS_WEAK, CRM_USER } from '@/config/storage';
import dayjs from 'dayjs';
import {
  getCmsCourseTree, getTeacherClass,
  getCommonWeakTagCodeList, getCommonWeakTagList,
  getClassSubjectList, getClassSGVList,
} from '@/api/pt';
import LoDialog from './components/lo-dialog.vue';
import ChoiseCategory from './components/choose-category.vue';
import ChoiseEvaCategory from './components/choose-eva-category.vue';
import ChooseKnowledgePoints from './components/choose-knowledgePoints.vue';

export default {
  name: 'ExerciseCommonWeak',
  components: {
    ChoiseCategory,
    ChoiseEvaCategory,
    ChooseKnowledgePoints,
    LoDialog,
  },
  props: {
    exerciseType: {
      type: [String, Boolean],
    },
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    return {
      radio: '1',
      total: 0,
      fromType: 6,
      courrentTestIds: [],
      courrentModuleId: '',
      currentItem: {},
      sortOrder: 1,
      sortName: 1,
      searchForm: {
        class_id: '',
        formatTime: '',
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      currentTagCode: '',
      scienceArr: [2, 4, 5],
      showVersion: false,
      userInfo,
      chapterList: [],
      packInfoList: [],
      classList: [],
      dateRange: [Date.now() - 30 * 24 * 3600 * 1000, Date.now()],
      selectedYear: 2021,
      visibleLo: false,
      yearList: [{
        // 后端让写死的
        value: 2021,
        label: '2021学年',
      }],
      pageSize: 20,
      currentPage: 1,
      visibleCancel: false,
      pickerMinDate: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近14天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          },
        }],
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
              return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
            }
            return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
          }
          return time.getTime() > Date.now();
        },

      },
      chooseWeakPointList: [],
      currentCourseName: '全部',
      currentCourseId: '',
      time: '',
      testId: '',
    };
  },
  computed: {
    ...mapGetters([
      'commonWeakCategoryObj',
      'questionsBasket',
      'filtrateArray',
      'checkedWeakPointList',
      'evaWeakCategoryObj',
    ]),
    category() {
      if (!this.exerciseType) {
        return this.evaWeakCategoryObj;
      }
      return this.commonWeakCategoryObj;
    },
  },
  watch: {
    'searchForm.class_id': {
      handler(newV, oldV) {
        this.pageSize = 20;
        this.currentPage = 1;
        if (newV !== oldV) {
          localStorage.setItem(CACHED_CLASS_WEAK, JSON.stringify(newV));
          if (this.exerciseType) {
            this.$nextTick(this.getCmsSubjectList());
            this.queryCommonWeakTagCodeList();
          }
          if (!this.exerciseType) {
            this.$nextTick(() => {
              this.$refs.ChoiseEvaCategory.getAccurateCategory('subjects', this.searchForm.class_id);
            });
          }
          this.showVersion = false;
          // this.queryCommonWeakTagCodeList();
        }
      },
      // immediate: true,
    },
    radio: function changeRadio(newV) {
      this.pageSize = 20;
      this.currentPage = 1;
      if (newV === '2') {
        this.pickChange();
      } else {
        this.queryCommonWeakTagCodeList();
      }
    },
  },
  methods: {
    notCnEn(subjectId) {
      console.log({ subjectId }, !([1, 3, '1', '3'].includes(subjectId)));
      return !([1, 3, '1', '3'].includes(subjectId));
    },
    onSortChange(e) {
      const { prop, order } = e;
      this.sortName = prop === 'rate' ? 2 : 1;
      this.sortOrder = order === 'descending' ? 0 : 1;
      this.queryCommonWeakTagCodeList();
    },
    // 获取布置年级
    getTeacherClassYear() {
      return getTeacherClass({ id: '' }).then((res) => {
        if (res.code === 200) {
          this.classList = res.data;
          const cachedClass = JSON.parse(localStorage.getItem(CACHED_CLASS_WEAK) || null);
          if (cachedClass) {
            this.searchForm.class_id = cachedClass;
          } else {
            this.searchForm.class_id = this.classList[0].code;
          }
        }
      });
    },
    onDataChange(data) {
      this.courrentTestIds = [];
      this.chapterList = data;
      this.chapterList.forEach((v) => {
        this.courrentTestIds.push(v.test_id);
      });
      this.showVersion = false;
      this.queryCommonWeakTagCodeList();
    },
    // 知识点点击查看详情操作
    handleEdit(index, item) {
      this.visibleLo = true;
      this.currentTagCode = item.tag_code;
      this.testId = item.test_id;
    },
    // 知识点选择操作
    handleSelectionChange(val) {
      console.log('val--------------', val);
      this.chooseWeakPointList = val;
      this.$store.commit('SET_WEAK_POINT_LIST', this.chooseWeakPointList);
    },

    // 时间筛选
    pickChange() {
      this.pageSize = 20;
      this.currentPage = 1;
      if (this.dateRange) {
        const startDate = dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = dayjs(this.dateRange[1]).format('YYYY-MM-DD');
        console.log(startDate, endDate);
        this.searchForm.formatTime = `${startDate}/${endDate}`;
        this.searchForm.startDate = startDate;
        this.searchForm.endDate = endDate;
      } else {
        this.searchForm.formatTime = '';
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
      if (this.radio === '2') {
        this.queryCommonWeakTagCodeList();
      }
    },
    handleSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.queryCommonWeakTagCodeList();
      } else {
        this.handleCurrentChange(1);
      }
    },
    handleCurrentChange(v) {
      this.currentPage = v;
      this.queryCommonWeakTagCodeList();
    },
    onCancelPublish() {
      console.log('取消布置');
      this.chooseWeakPointList = [];
      this.$store.commit('SET_WEAK_POINT_LIST', this.chooseWeakPointList);
      this.visibleCancel = false;
    },
    onCancelClick() {
      this.$refs.multipleTable.clearSelection();
      this.visibleCancel = true;
    },
    onConfirmPublish() {
      if (this.chooseWeakPointList.length === 0) {
        this.$message({
          message: '请先勾选要布置的知识点',
          type: 'worry',
        });
        return;
      }
      if (this.chooseWeakPointList.length > 20) {
        this.$message({
          message: '最多选择20个知识点',
          type: 'worry',
        });
        return;
      }
      this.$router.push({
        path: '/pt/publish-weak-point',
        query: {
          exerciseType: this.exerciseType,
        },
      });
    },
    getRateClass(rate) {
      if (rate > 70) {
        return 'is-green';
      }
      if (rate > 40) {
        return 'is-orange';
      }
      return 'is-red';
    },
    // 重新选择版本操作
    hideSubjectGradeText(isNeedQuery) {
      this.showVersion = false;
      if (this.exerciseType && isNeedQuery) {
        this.queryCourseTree();
      }
    },
    // 查询当前版本章节列表
    queryCourseTree() {
      this.chapterList = [];
      this.subjectId = this.category.subjectId;
      this.gradeId = this.category.gradeId;
      this.textbookId = this.category.textbookId;
      this.termId = this.category.termId;
      const params = {
        subject_id: this.subjectId,
        grade_id: this.gradeId,
        textbook_id: this.textbookId,
        extend_info: 1,
        term_id: this.termId,
        hw_type: 3,
      };
      getCmsCourseTree(params).then((res) => {
        if (res.code === 200) {
          this.courrentModuleId = '';
          const chapterArr = res.data;
          chapterArr.forEach((item) => {
            this.chapterList.push({
              course_id: item.course_id,
              lesson_id: item.lesson_id,
              lesson_name: item.lesson_name,
              module_id: item.module_id,
              module_name: item.module_name,
              active: false,
            });
          });
          // this.currentCourseName = chapterArr[0].course_name;
          this.currentCourseId = chapterArr[0].course_id;
          // 练习中心进来的获取知识点列表
          const courseInfo = {
            courseId: chapterArr[0].course_id,
            courseName: chapterArr[0].course_name,
          };
          this.$store.commit('CHANGE_COMMON_WEAK_COURSE', courseInfo);
          this.queryCommonWeakTagCodeList();
        }
      });
    },
    async queryCommonWeakTagCodeList() {
      this.time = this.radio === '1' ? this.selectedYear : this.searchForm.formatTime;
      if (this.exerciseType) {
        const params = {
          class_id: this.searchForm.class_id,
          course_id: this.currentCourseId,
          subject_id: this.category.subjectId,
          module_id: this.courrentModuleId || 0,
          req_type: this.radio === '1' ? 1 : 2,
          time: this.radio === '1' ? this.selectedYear : this.searchForm.formatTime,
          curr_page: this.currentPage,
          page_size: this.pageSize,
          sort: this.sortOrder,
          sort_name: this.sortName,
        };
        await getCommonWeakTagCodeList(params).then((res) => {
          this.packInfoList = [];
          if (res.code === 200) {
            const knowledgeArr = res.data.list;
            this.total = res.data.total;
            if (knowledgeArr.length > 0) {
              knowledgeArr.forEach((knowledge, index) => {
                console.log(index);
                this.packInfoList.push({
                  tag_code: knowledge.tag_code,
                  tag_name: knowledge.tag_name,
                  avg_ability: knowledge.avg_ability,
                  rate: `${knowledge.low_ability_num}/${knowledge.stu_num}`,
                  active: false,
                  test_id: knowledge.course_id,
                });
              });
            }
          }
        });
      } else {
        const params = {
          class_id: this.searchForm.class_id,
          req_type: this.radio === '1' ? 1 : 2,
          time: this.radio === '1' ? this.selectedYear : this.searchForm.formatTime,
          curr_page: this.currentPage,
          page_size: this.pageSize,
          sort: this.sortOrder,
          sort_name: this.sortName,
          test_ids: this.courrentTestIds,
        };
        await getCommonWeakTagList(params).then((res) => {
          this.packInfoList = [];
          if (res.code === 200) {
            const knowledgeArr = res.data.list;
            this.total = res.data.total;
            if (knowledgeArr.length > 0) {
              knowledgeArr.forEach((knowledge) => {
                this.packInfoList.push({
                  tag_code: knowledge.tag_code,
                  tag_name: knowledge.tag_name,
                  avg_ability: knowledge.avg_ability,
                  rate: `${knowledge.low_ability_num}/${knowledge.stu_num}`,
                  active: false,
                  test_id: knowledge.test_id,
                });
              });
            }
          }
        });
      }
    },
    // 章节点击操作
    onChangeCourse(item) {
      this.pageSize = 20;
      this.currentPage = 1;
      if (this.exerciseType) {
        this.currentCourseName = item.module_name;
        this.courrentModuleId = item.module_id;
      } else {
        this.courrentTestIds = [];
        this.currentCourseName = item.test_name;
        this.courrentTestIds.push(item.test_id);
        const testInfo = {
          testId: item.test_id,
          testName: item.test_name,
        };
        this.$store.commit('CHANGE_TEST_INFORMATION', testInfo);
      }
      this.currentItem = item;
      this.queryCommonWeakTagCodeList();
    },
    async getCmsSubjectList() {
      const res = await getClassSubjectList({
        hw_type: 4,
        class_id: this.searchForm.class_id,
      });
      if (res.code === 200) {
        const arr = res.data[0];
        this.currentSubject = arr;
      }
      this.querySGVList();
    },
    async querySGVList() {
      await getClassSGVList({
        subject_id: this.currentSubject.subject_id,
        hw_type: 3,
        class_id: this.searchForm.class_id,
      }).then((res) => {
        if (res.code === 200) {
          const { grade } = res.data;
          const gradeArr = grade[0];
          const textArr = grade[0].textbook[0];
          this.currentGrade = gradeArr;
          this.currentTextBook = textArr;
        }
      });
      const category = JSON.parse(localStorage.getItem(`commonWeak-last_${this.searchForm.class_id}`)) || {};
      const cateGoryObj = {
        subjectId: this.currentSubject.subject_id,
        subjectName: this.currentSubject.subject_name,
        gradeId: this.currentGrade.grade_id,
        gradeName: this.currentGrade.grade_name,
        termId: this.currentGrade.term_id,
        termName: this.currentGrade.term_name,
        textbookId: this.currentTextBook.textbook_id,
        textbookName: this.currentTextBook.textbook_name,
      };
      if (category.subjectId !== undefined) {
        this.$store.commit('SET_COMMON_WEAK_CATEGORY_OBJ', category);
      } else {
        this.$store.commit('SET_COMMON_WEAK_CATEGORY_OBJ', cateGoryObj);
      }
      this.queryCourseTree();
    },
  },
  async created() {
    await this.getTeacherClassYear();
    // if (!this.exerciseType) {
    //   this.$refs.ChoiseEvaCategory.getAccurateCategory('subjects');
    // }
  },
};
</script>

<style lang="scss" scoped>
.c-common-weak {
  .point-content {
    padding: 24px;
  }
  /deep/.el-table__empty-text {
    width: 100%;
  }
  .no-data {
    background: rgba(250, 253, 255, 1);
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(17, 31, 44, 0.6);
    font-size: 14px;
    flex-direction: column;
    img {
      width: 159px;
      height: 119px;
    }
  }
  .cancel-mask {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    .cancel-dialog {
      width: 510px;
      height: 270px;
      background: #ffffff;
      border-radius: 16px;
    }
    .dialog-content {
      text-align: center;
      color: rgba(17, 31, 44, 1);
      font-size: 20px;
      padding: 60px 0 50px;
      p {
        line-height: 36px;
      }
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
      .btn-cancel {
        width: 120px;
        height: 40px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #a3d0fd;
        box-sizing: border-box;
        color: rgba(25, 137, 250, 1);
        font-size: 15px;
      }
      .btn-confirm {
        width: 120px;
        height: 40px;
        background: #1989fa;
        border-radius: 4px;
        color: #fff;
        font-size: 15px;
        margin-left: 32px;
      }
    }
  }
  .c-header {
    .c-title {
      color: #000;
      font-size: 17px;
      font-weight: bold;
    }
    .c-subtitle {
      color: #000;
      font-size: 14px;
    }
    .c-text {
      font-size: 15px;
      color: #000;
      font-weight: bold;
      i {
        color: rgba(25, 137, 250, 1);
        font-style: normal;
      }
    }
    .c-cancel {
      width: 120px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      color: rgba(96, 98, 102, 1);
      font-size: 15px;
      box-sizing: border-box;
      margin-left: 16px;
    }
    .c-confirm {
      color: #fff;
      background: rgba(25, 137, 250, 1);
      font-size: 15px;
      width: 210px;
      height: 40px;
      border-radius: 4px;
      margin-left: 16px;
    }
    .c-no-confirm {
      color: #fff;
      background: #ccc;
      font-size: 15px;
      width: 210px;
      height: 40px;
      border-radius: 4px;
      margin-left: 16px;
      cursor: pointer;
    }
  }
  .c-empty {
    width: 209px;
    height: 147px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 30px;
  }
  .is-green {
    color: rgba(26, 191, 95, 1);
    padding-left: 8px;
  }
  .is-red {
    color: rgba(245, 108, 108, 1);
    padding-left: 8px;
  }
  .is-orange {
    color: orange;
    padding-left: 8px;
  }
  .c-progress {
    display: inline-block;
    position: relative;
    width: 96px;
    height: 10px;
    background: #d7e1ed;
    border-radius: 6px;
    overflow: hidden;
    i {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background: linear-gradient(227deg, #a6a0ff 0%, #3383ff 100%);
    }
  }
  .create-at-content {
    display: flex;
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    bottom: -10px;
    left: 30px;
  }
  /deep/.el-table {
    thead th {
      background: rgba(240, 244, 245, 1);
    }
    tr {
      background: rgba(250, 253, 255, 1);
    }
  }
  .c-view {
    color: rgba(25, 137, 250, 1);
    font-size: 14px;
    cursor: pointer;
  }
  .f-left {
    width: 256px;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    padding-top: 6px;
    min-height: 680px;
    z-index: 2;
  }
  .f-main {
    flex: 1;
    position: relative;
  }
  .s-container {
    display: flex;
    align-items: center;
    padding: 17px;
    .f-label {
      color: #000;
      font-size: 15px;
      margin-right: 10px;
    }
    /deep/ .el-radio {
      margin-right: 10px;
      .el-radio__label {
        padding: 0px;
        color: #000;
        font-size: 15px;
      }
    }
  }
  .selector-container {
    margin-bottom: 30px;
    .version-header {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #c4c8d2;
      line-height: 40px;
      font-size: 14px;
      padding: 0 15px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .is-blue {
      border: 1px solid #1989fa;
    }
  }
  .c-subtile {
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    margin-top: 40px;
    padding-bottom: 20px;
  }
  .basket {
    position: fixed;
    top: 160px;
    right: 0px;
    width: 56px;
    height: 170px;
    background: #1989fa;
    box-shadow: 0px 2px 6px 0px rgba(129, 172, 223, 0.51);
    border-radius: 8px;
    .basket-content {
      padding-top: 30px;
      text-align: center;
      margin: 10px auto;
      width: 26px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: url("../images/question_basket.png") no-repeat;
      background-size: 26px 24px;
    }
    .basket-number {
      margin: 16px auto;
      width: 38px;
      height: 38px;
      background: #81acdf;
      border-radius: 50%;
      line-height: 38px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
